module.exports = __webpack_public_path__ + "img/reel.41675ee3.svg";